import type { TFunc } from "../i18n";

function messageOf(error: unknown): string {
  return error instanceof Error ? error.message : "";
}

export function formatBillingError(error: unknown, t: TFunc, fallback: string): string {
  const message = messageOf(error);

  if (/no API key provisioned/i.test(message)) {
    return t("billing.noBillingKey");
  }
  if (/missing payment client secret/i.test(message)) {
    return t("billing.missingClientSecret");
  }
  if (/failed to fetch|fetch failed|load failed|network\s*error|network request failed|could not reach stripe/i.test(message)) {
    return t("billing.networkFailed");
  }

  return message || fallback;
}
